import {type CounterTracker, Message, State, Update} from '../AppState'
import { useReducer, useState } from 'react';
import CounterBox from './CounterBox'
import useWebSocket from 'react-use-websocket';
import Counter from './Counter';
import useMousePosition from '../hooks/useMousePosition';


const location = (index: number, size: number) => {
  const boxes_per_side = size - 1;
  const side = Math.floor( index / boxes_per_side);
  const position = index % boxes_per_side;
  if (side == 0) {
      return {
          row: 1, 
          column: position
      }
  } else if (side == 1) {
      return {
          row: 1 + position,
          column: size
      }
  } else if (side == 2) {
      return {
          row: size,
          column: size - position
      }
  } else if (side == 3){
      return {
          row: size - position,
          column: 1
      }
  }
  else throw new Error(`Index ${index} out of bounds for grid size ${size}`)
}

const updateState: (state: State, message: Update) => State = (state: State, message: Update) => {
  if (message.kind === "counterUpdate") {
    return {
      ...state,
      counters: message.counters
    }
  }

  else if (message.kind==="positionUpdate"){
    const newPositions = {
      ...state.positions
    };

    const vpPosition = {
      x: message.position.pctX * window.visualViewport?.width,
      y: message.position.pctY * window.visualViewport?.height
    }
    newPositions[message.clientId] = {
      position: vpPosition,
      visible: message.visible
    } 

  return {
      ...state,
      positions: newPositions
    }
  }

  return {
    ...state
  }
}

export default function CounterBoard({initialCounters}: {initialCounters: CounterTracker}) {
  const initialState: State = {
    counters: initialCounters, 
    positions: {},
    id: Math.random()
  }
  const [state, dispatch] = useReducer(updateState, initialState)
  const n_books = Object.entries(state.counters).length
  let size = 3; 
  while (size ** 2 - (size - 2) ** 2  < n_books) { 
    size += 2
  }
  console.log("size: ", size)

  const center = {
    row: Math.ceil(size / 2),
    column: Math.ceil(size / 2)
  }
  const mousePosition = useMousePosition()
  const [webSocketUrl, _ ] = useState("/ws/counters")
  const {sendJsonMessage} = useWebSocket(webSocketUrl, {
    share: true,
    onMessage: (event)=> {
      console.log("Got update", event)
      dispatch(JSON.parse(event.data)
      )
    }
  })

  
  const [counterVisible, setCounterVisible] = useState(false)
  const updateCounter = (visible: boolean) => {
      const msg: Message = {
        kind: 'positionUpdate', 
        clientId: state.id,
        position: mousePosition,
        visible: visible
      }
      sendJsonMessage(msg);
      setCounterVisible(visible);
    }

  if (counterVisible) {
    const msg: Message = {
      kind: 'positionUpdate', 
      clientId: state.id,
      position: mousePosition,
      visible: counterVisible
    }
    sendJsonMessage(msg)
  }


  return (
    <div id="counterBoard">
      <h2> Counters </h2>
      <div id="datapad" style={{
        display: "grid", 
        gap: "1em",
        gridTemplateColumns: `repeat(${size}, 1fr)`,
      }}
      > {
        Object.entries(state.counters).map(([playbook, n_counters], index)=> {
        return (<><CounterBox 
          n_counters={n_counters} 
          name={playbook} 
          sendJsonMessage={sendJsonMessage}
          key={playbook}
          updateCounter={updateCounter}
          location={location(index, size)}/></>)})
        }
        <CounterBox updateCounter={updateCounter}
        n_counters={1/0} name='source' sendJsonMessage={()=>{}} 
        location={center} />
        {
          Object.values(state.positions).map((entry)=>{
            return <Counter position={entry.position} visible={entry.visible} />
          })
        }
        </div>
    </div>
  );
}
